// ----------------------------------------------------------------------
// <copyright file="Izenda.OperatorValueInputWithMode.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Validator from 'share/components/hoc/Izenda.Validator';
import Input from 'share/components/controls/Izenda.Input';
import Select from 'share/components/controls/multiSelectBox/Izenda.Select';
import classnames from 'classnames';
import {
  ERROR_MESSAGE_BY_DATA_TYPE,
  DATA_TYPE,
  REGEX,
  SELECT_SETTINGS,
  SELECT_MODE,
  CONSTRAINTS,
  CONSTRAINTS_NAME,
  DEFAUFT_VALUE,
  DELIMITER_TYPE
} from 'logic/data/Izenda.FilterDetailsConfigConstants';
import { isEmpty, map, identity, isNil, get, isArray } from 'lodash/fp';
const { BLANK, NULL } = DEFAUFT_VALUE;
const SelectValidator = Validator()(Select);

@connect()
export default class OperatorValueInputWithMode extends Component {
  state = {
    errorMessage: ''
  };

  static propTypes = {
    filterInfo: React.PropTypes.object.isRequired,
    viewMode: React.PropTypes.bool,
    applyFormater: React.PropTypes.func
  };

  static defaultProps = { applyFormater: identity };

  /**
   * Handle switch component to select multiple or signle
   * @param  {object} e React event
   */
  switchToSingleOrMultiple = value => {
    const {
      validation,
      onChange,
      filterInfo,
      operatorGroup,
      operatorGroup: {
        fieldDetails: { operatorSetting }
      }
    } = this.props;
    validation.reset();

    const isMultipleMode = this.checkMultipleMode(operatorSetting).isMultiple;
    const multiTypeMode = this.checkMultipleMode(operatorSetting).multipleType;
    const isMultipleCheck = this.checkMultipleMode(value).isMultiple;
    const multiTypeCheck = this.checkMultipleMode(value).multipleType;
    const values = this.getValueFromSource(filterInfo.value.sort()) || [];

    let result = [];
    if (isMultipleMode === isMultipleCheck && multiTypeMode === multiTypeCheck) {
      return;
    }

    if (isMultipleCheck) {
      if (isArray(values)) {
        result = values.map(data => data.value);
      } else {
        result = isMultipleCheck ? [values.value] : [];
      }
    }

    onChange && onChange(result);
    operatorGroup.fieldDetails.setOperatorSetting(value);
  };

  /**
 * Handle switch component to signle
 */
  switchToSingle = () => {
    this.switchToSingleOrMultiple(SELECT_SETTINGS.SINGLE);
  };

  /**
  * Handle switch component to multiple
  */
  switchToMultiple = (mode) => {
    this.switchToSingleOrMultiple(mode);
  };

  /**
   * Handle when change value of selectbox
   * @param  {object} selectValues list select value
   */
  onChangeInput = selectValues => {
    const {
      onChange,
      operatorGroup: {
        fieldDetails: { operatorSetting }
      }
    } = this.props;
    const isMultipleMode = this.checkMultipleMode(operatorSetting).isMultiple;
    const multiType = this.checkMultipleMode(operatorSetting).multipleType;

    let result = [];

    // when remove value
    if (!isNil(selectValues)) {
      if (isMultipleMode) {
        result = map(item => item.value, selectValues);
      } else {
        result = [selectValues.value];
      }
    }

    onChange && onChange(result);
  };

  /**
   * Handle when add new value of selectbox
   * @param  {object} newValue new value of select box
   * @return {boolean}         result of add new value
   */
  onAddNewInput = newValue => {
    const { validation, operatorGroup } = this.props;
    const dataType = operatorGroup.fieldDetails.useLookup ? DATA_TYPE.TEXT : operatorGroup.fieldDetails.dataType;
    const errorMessage = get(dataType, ERROR_MESSAGE_BY_DATA_TYPE);

    if (!this.validationValue(newValue.value, dataType)) {
      validation.updateErrors([{ key: CONSTRAINTS_NAME, messages: errorMessage }]);
      return false;
    }

    return true;
  };

  /**
   * Validation when add new value for selectbox
   * @param  {object} value    validate value
   * @param  {string} dataType data type of value
   * @return {boolean}         result of validate
   */
  validationValue(value, dataType) {
    switch (dataType) {
      case DATA_TYPE.TEXT:
        return true;
      case DATA_TYPE.TIME:
        return String.isPatternFormat(value, REGEX.TIME);
      case DATA_TYPE.MONEY:
      case DATA_TYPE.NUMBER:
        return (
          String.isPatternFormat(value, REGEX.NUMBER) ||
          value.toUpperCase() === NULL ||
          value.toUpperCase() === BLANK
        );
      case DATA_TYPE.DATE:
        return (
          String.isPatternFormat(value, REGEX.DATETIMEFORMAT) ||
          value.toUpperCase() === NULL ||
          value.toUpperCase() === BLANK
        );
      default:
        return true;
    }
  }

  /**
   * Get value from source for selectbox
   * @param  {array} filter value
   * @return         array or object base on component multiple or single settings
   */
  getValueFromSource = source => {
    const {
      applyFormater,
      operatorGroup: {
        fieldDetails: { operatorSetting }
      }
    } = this.props;
    const isMultipleMode = this.checkMultipleMode(operatorSetting).isMultiple;
    let result;

    if (isMultipleMode) {
      result = map(item => ({ value: item, label: applyFormater(item) }), source);
      // Remove empty value
      // if (result.length === 1 && isEmpty(result[0].value)) {
      //   result = [];
      // }
    } else {
      result = isEmpty(source) ? null : { value: source[0], label: applyFormater(source[0]) };
    }

    return result;
  };

  checkMultipleMode(value) {
    return {
      isMultiple: !!value && !(value === SELECT_SETTINGS.SINGLE),
      multipleType: value
    }
  }

  renderSelectBox() {
    const {
      localization,
      operatorGroup: {
        fieldDetails: { operatorSetting }
      }
    } = this.props;
    const isMultipleMode = this.checkMultipleMode(operatorSetting).isMultiple;
    const multiType = this.checkMultipleMode(operatorSetting).multipleType;
    return (
      <div>


        <div>
          <Input
            type="radio"
            checked={!isMultipleMode}
            onChange={this.switchToSingle}
            value={SELECT_SETTINGS.SINGLE}
            disabled={this.props.disabled}
          />
          {SELECT_MODE.SINGLE} &nbsp;
        <Input
            type="radio"
            checked={isMultipleMode}
            onChange={() => this.switchToMultiple(SELECT_SETTINGS.MULTIPLE)}
            value={SELECT_SETTINGS.MULTIPLE}
            disabled={this.props.disabled}
          />{' '}
          {SELECT_MODE.MULTIPLE}
        </div>
        {
          (isMultipleMode) && (
            <div className="izenda-mt-10">
              <p>{localization.getText('REPORTDESIGNER_LABEL_DELIMITER_VALUE')}</p>
              <div className='u_inlineBlock'>
                <Input
                  type='radio'
                  checked={multiType === SELECT_SETTINGS.MULTIPLE}
                  onChange={() => this.switchToMultiple(SELECT_SETTINGS.MULTIPLE)}
                  value={SELECT_SETTINGS.MULTIPLE}
                  disabled={false}
                />
                {SELECT_MODE.MULTIPLE_NONE} &nbsp;
               </div>
              <div className='u_inlineBlock'>
                <Input
                  type='radio'
                  checked={multiType === SELECT_SETTINGS.MULTIPLE_COMMA}
                  onChange={() => this.switchToMultiple(SELECT_SETTINGS.MULTIPLE_COMMA)}
                  value={SELECT_SETTINGS.MULTIPLE_COMMA}
                  disabled={false}
                />
                {SELECT_MODE.MULTIPLE_COMMA} &nbsp;
               </div>
              <div className='u_inlineBlock'>
                <Input
                  type='radio'
                  checked={multiType === SELECT_SETTINGS.MULTIPLE_NEWLINE}
                  onChange={() => this.switchToMultiple(SELECT_SETTINGS.MULTIPLE_NEWLINE)}
                  value={SELECT_SETTINGS.MULTIPLE_NEWLINE}
                  disabled={false}
                />
                {SELECT_MODE.MULTIPLE_NEW_LINE} &nbsp;
               </div>
            </div>
          )}
      </div>
    );
  }

  // onCommaTextChanges(e) {
  //   const {
  //     onChange,
  //     operatorGroup: {
  //       fieldDetails: { operatorSetting }
  //     }
  //   } = this.props;
  //   let result = [];
  //   let data = e.target.value;
  //   let actualData = data.split(',');
  //   let selectValues = map(innerData => ({ value: innerData, label: innerData }), actualData);
  //   result = map(item => item.value, selectValues);
  //   onChange && onChange(result);
  // }

  onTextAreaChange(e) {
    const props = this.props;
    const {
      onChange,
      operatorGroup: {
        fieldDetails: { operatorSetting }
      }
    } = props;
    const multiType = this.checkMultipleMode(operatorSetting).multipleType;
    let selectValues = [];
    const data = e.target.value;
    if (multiType === SELECT_SETTINGS.MULTIPLE_NEWLINE) {
      selectValues = data
        .replace(/\n/g, DELIMITER_TYPE.NEWLINE)
        .split(DELIMITER_TYPE.NEWLINE)
    } else if (multiType === SELECT_SETTINGS.MULTIPLE_COMMA) {
      selectValues = data.split(',');
    }

    selectValues = selectValues
      .map(data => data.trim())
    // .filter(data => data)
    onChange && onChange(selectValues);
  }

  onTextAreaKeyPress(e) {
    if (e && e.keyCode == 13) {
      this.props.store.reportStore.alertDetails.set({
        success: true,
        message: 'Filter values set successfully',
        showType: 'reset',
      })
      this.props.closePopover && this.props.closePopover();
      return;
    }
  }

  getValuesForNewLine(values) {
    return values.map(data => data.value).join('\n');
  }

  getValuesForComma(values) {
    return values.map(data => data.value).join(',');
  }

  renderInputField() {
    const {
      filterInfo,
      labelField,
      valueField,
      disabled,
      localization,
      operatorGroup: {
        fieldDetails: { operatorSetting }
      }
    } = this.props;
    const isMultipleMode = this.checkMultipleMode(operatorSetting).isMultiple;
    const values = this.getValueFromSource(filterInfo.value);
    const multiType = this.checkMultipleMode(operatorSetting).multipleType;
    const textAreaStyle = classnames({ 'izenda-mt-10': !this.props.closePopover }, { 'izenda-w-50': this.props.closePopover })
    if (multiType === SELECT_SETTINGS.MULTIPLE_NEWLINE) {
      return (<div className={textAreaStyle}>
        <textarea
          className="form-control"
          placeholder={localization.getText('REPORTDESIGNER_NEWLINE_DELIMITER_PLACEHOLDER')}
          rows="3"
          onChange={(e) => this.onTextAreaChange(e)}
          value={this.getValuesForNewLine(values)}
        //  onKeyDown={(e) => this.onTextAreaKeyPress(e)}
        />
      </div>)
    } else if (multiType === SELECT_SETTINGS.MULTIPLE_COMMA) {
      return (<div className={textAreaStyle}>
        <textarea
          className="form-control"
          placeholder={localization.getText('REPORTDESIGNER_NEWLINE_DELIMITER_PLACEHOLDER')}
          rows="3"
          onChange={(e) => this.onTextAreaChange(e)}
          value={this.getValuesForComma(values)}
        //  onKeyDown={(e) => this.onTextAreaKeyPress(e)}
        />
      </div>)
    } else {
      return (<div className="select-box-container">
        <SelectValidator
          multi={isMultipleMode}
          options={[]}
          labelKey={labelField}
          valueKey={valueField}
          scalable={false}
          value={values}
          onChange={this.onChangeInput}
          onAddNew={this.onAddNewInput}
          field={CONSTRAINTS_NAME}
          validations={CONSTRAINTS}
          disabled={disabled}
          textboxMode={true}
          noResultsText={null}
          inputMaxHeight={0}
        />
      </div>)
    }
  }
  /**
   * Render component
   */
  render() {
    const {
      viewMode

    } = this.props;
    return (
      <div className="manual-entry">
        {!viewMode && this.renderSelectBox()}
        {this.renderInputField()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/OperatorValue/Izenda.OperatorValueInputWithMode.js